import Vue from 'vue';

const SET_CONFIG = 'SET_CONFIG';

const state = {
	config: {}
};

const getters = {
	ENVIRONMENT: state => state.config.ENVIRONMENT,
	OPTIMUS_API: state => state.config.OPTIMUS_API,
	DATA_SERVICE_API: state => state.config.DATA_SERVICE_API,
	THEME_URL: state => state.config.THEME_URL,
	APP_URL: state => state.config.APP_URL,
	AUTH_API: state => state.config.AUTH_API,
	AUTH_URL: state => state.config.BRAND.authURL,
	ACCOUNT_API:state => state.config.ACCOUNT_API,
	BRAND: state => state.config.BRAND,
};

const actions = {
	[SET_CONFIG]: ({ commit, dispatch }, config) => {
		commit(SET_CONFIG, config);
	}
};

const mutations = {
	[SET_CONFIG]: (state, config) => {
		config.BRAND = config.BRANDS[config.BRAND];
		state.config = config;

		document.title = 'Integrations - ' + config.BRAND.name;
	}
};

export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/modules/config/store.js